module.exports = __webpack_public_path__ + "img/yandex.60e7de7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/yandex.png
// module id = ./assets/yandex.png
// module chunks = 152